export default __webpack_public_path__ + "static/media/wSweats_1_p1.aa2b2f5f.jpeg";